import { answerCollection } from "../../constants/right_answer";

export const tableDataTransform = (data,dataTest,calculateData, shortNames) => {
    const result=[];

    const auditors_full_names = data.auditors_full_names;
    const test=dataTest.data;

    if(data.esteem_audit_id!=null){
        const esteem_results=data.esteem_results
    }
    
    Object.keys(data.results).forEach((partName)=>{
        Object.keys(data["results"][partName]).forEach((categoryName)=>{
            Object.keys(data["results"][partName][categoryName]).forEach((levelName)=>{
                Object.keys(data["results"][partName][categoryName][levelName]).forEach((taskName)=>{
                    // console.log(`${partName}-${categoryName}-${levelName}-${taskName}`)
                    let lineValue={
                        "part_name": partName,
                        "category": `${shortNames[partName][categoryName]}. ${categoryName}`,
                        "auditor": auditors_full_names[partName][categoryName].join("; "),
                        "level":levelName,
                        "task": test[partName][categoryName][levelName][taskName]["additional_info"]["index"],
                        "task_number":taskName,
                        "answer": answerCollection[data["results"][partName][categoryName][levelName][taskName]],
                        "comment":data["comments"][partName][categoryName][levelName][taskName],
                        "taskText":test[partName][categoryName][levelName][taskName]["task_value"],
                        "taskControlElement":test[partName][categoryName][levelName][taskName]["control_element"],
                    }
                    
                    if(data.esteem_audit_id!==null){
                        lineValue["esteem_result"]=answerCollection[data["esteem_results"][partName][categoryName][levelName][taskName]];
                        lineValue["esteem_comment"]=data["esteem_comments"][partName][categoryName][levelName][taskName];
                    }
                    result.push(lineValue)
                })
            })
        })
    })
    return result
}


//функция для подсчёта оценок для excel файла
export default function ExcelTableDataTransform(data, full_audit_data, calculate_data){
    //data - переменная с данными об аудите
    //full_audit_data -переменная с полными данными об аудите(самоаудит+ условия задач)

    //Список правильных ответов для теста
    const write_answer={"Да":true,"1.Да":true,"true":true}

    const answer_collection={[true]:"1",[false]:"0",[null]:""}
    
    //итоговые данные
    const result_data={}

    let excel_score_list=calculate_data.data_count.map((item)=> {return {"раздел":item.name,"оценка":item.value}})
    excel_score_list.push({"раздел":"Общая оценка","оценка":calculate_data.summary})
    
    Object.assign(result_data,{"общее":excel_score_list})

    //список разделов
    const array_part_name=Object.keys(data.results)   
    //1)перебираем разделы
    for (var index_part_name in array_part_name){
        //название выбранного раздела
        let part_name=array_part_name[index_part_name]
         //Список подразделов в разделе
        let array_category=Object.keys(data.results[part_name])

        let result_part_name_data=[]
        //перебираем подразделы
        for (var index_category in array_category){
            //выбранный подраздел
            let category=array_category[index_category]
            //список уровней в подразделе
            let array_level=Object.keys(data.results[part_name][category])

            let array_count_answer_levels=[]
            let array_selfesteem=[]

            //перебираем уровни
            for (var index_level in array_level){
                //выбранный уровень
                let level=array_level[index_level]
                //список заданий в уровне
                let array_tasks=Object.keys(data.results[part_name][category][level])

                //Подсчёт результатов в задании:
                //Количество отрицательных и неотвеченных вопросов
                let count_no_or_null_in_level=Object.values(data.results[part_name][category][level]).filter(val => write_answer[String(val)] !== true).length
                //Количество отвеченных вопросов
                let count_yes_in_level=Object.values(data.results[part_name][category][level]).filter(val => write_answer[String(val)] === true).length
                //Количество вопросов в уровне
                let count_tasks_in_level=Object.keys(data.results[part_name][category][level]).length

                //сохраняем
                array_count_answer_levels.push(count_yes_in_level)
                array_selfesteem.push(count_tasks_in_level)
                

                //перебираем каждое задание
                for (var index_task in array_tasks){
                    //выбранное номер задания в уровне
                    let task=array_tasks[index_task]
                    //проверка
                    // console.log(part_name+"-"+category+"-"+level+"-"+task)

                    //переменные в которых сохраняется оценка
                    let level_first_score=""
                    let level_second_score=""
                    let level_third_score=""
                    let level_four_score=""
                    let level_five_score=""

                    if (level==="1"){
                        level_first_score=answer_collection[data.results[part_name][category][level][task]]
                        level_second_score=""
                        level_third_score=""
                        level_four_score=""
                        level_five_score=""
                    }else if(level==="2"){
                        level_first_score=""
                        level_second_score=answer_collection[data.results[part_name][category][level][task]]
                        level_third_score=""
                        level_four_score=""
                        level_five_score=""
                    }else if(level==="3"){
                        level_first_score=""
                        level_second_score=""
                        level_third_score=answer_collection[data.results[part_name][category][level][task]]
                        level_four_score=""
                        level_five_score=""
                    }else if(level==="4"){
                        level_first_score=""
                        level_second_score=""
                        level_third_score=""
                        level_four_score=answer_collection[data.results[part_name][category][level][task]]
                        level_five_score=""
                    }else if(level==="5"){
                        level_first_score=""
                        level_second_score=""
                        level_third_score=""
                        level_four_score=""
                        level_five_score=answer_collection[data.results[part_name][category][level][task]]
                    }

                    //вариант 1 самоаудита нет
                    if (data.esteem_audit_id===null){
                        result_part_name_data.push({
                            "Подраздел":full_audit_data.data[part_name][category][level][task]["additional_info"]["category_code"]+" "+category,
                            "Аудитор":data.auditors_full_names[part_name][category].join("; "),
                            "Уровень 1":level_first_score,
                            "Уровень 2":level_second_score,
                            "Уровень 3":level_third_score,
                            "Уровень 4":level_four_score,
                            "Уровень 5":level_five_score,
                            "Номер":task,
                            "Пункт":full_audit_data.data[part_name][category][level][task]["additional_info"]["index"],
                            // "Код категории":full_audit_data.data[part_name][category][level][task]["additional_info"]["category_code"],
                            "Ответственный":full_audit_data.data[part_name][category][level][task]["additional_info"]["accountable"],
                            // "Ответ":data.results[part_name][category][level][task],
                            "Условие":full_audit_data.data[part_name][category][level][task]["task_value"],
                            "Контрольный элемент":full_audit_data.data[part_name][category][level][task]["control_element"],
                            "Комментарий":data.comments[part_name][category][level][task],
                        })
                    //вариант 2 самоаудит есть
                    }else{
                        result_part_name_data.push({
                            "Подраздел":full_audit_data.data[part_name][category][level][task]["additional_info"]["category_code"]+" "+category,
                            "Аудитор":data.auditors_full_names[part_name][category].join("; "),
                            "Уровень 1":level_first_score,
                            "Уровень 2":level_second_score,
                            "Уровень 3":level_third_score,
                            "Уровень 4":level_four_score,
                            "Уровень 5":level_five_score,
                            "Номер":task,
                            "Пункт":full_audit_data.data[part_name][category][level][task]["additional_info"]["index"],
                            // "Код категории":full_audit_data.data[part_name][category][level][task]["additional_info"]["category_code"],
                            "Ответственный":full_audit_data.data[part_name][category][level][task]["additional_info"]["accountable"],
                            // "Ответ":data.results[part_name][category][level][task],
                            "Условие":full_audit_data.data[part_name][category][level][task]["task_value"],
                            "Контрольный элемент":full_audit_data.data[part_name][category][level][task]["control_element"],
                            "Комментарий":data.comments[part_name][category][level][task],
                            "Оценка самоаудита":answer_collection[data.esteem_results[part_name][category][level][task]],
                            "Комментарий самоаудита":data.esteem_comments[part_name][category][level][task]
                        })
                    }
                }
            }
        //добвавляем 4 пустые строки после каждого подраздела
        if (data.esteem_audit_id===null){
            result_part_name_data.push({"Подраздел":null,"Аудитор":null,"Уровень 1":array_count_answer_levels[0],"Уровень 2":array_count_answer_levels[1],"Уровень 3":array_count_answer_levels[2],"Уровень 4":array_count_answer_levels[3],"Уровень 5":array_count_answer_levels[4],"Пункт":null,"Условие":null,"Контрольный элемент":null,"Комментарий":null})
            result_part_name_data.push({"Подраздел":null,"Аудитор":null,"Уровень 1":array_selfesteem[0],"Уровень 2":array_selfesteem[1],"Уровень 3":array_selfesteem[2],"Уровень 4":array_selfesteem[3],"Уровень 5":array_selfesteem[4],"Пункт":null,"Условие":null,"Контрольный элемент":null,"Комментарий":null})
        //вариант 2 самоаудит есть
        }else{
            result_part_name_data.push({"Подраздел":null,"Аудитор":null,"Уровень 1":array_count_answer_levels[0],"Уровень 2":array_count_answer_levels[1],"Уровень 3":array_count_answer_levels[2],"Уровень 4":array_count_answer_levels[3],"Уровень 5":array_count_answer_levels[4],"Пункт":null,"Условие":null,"Контрольный элемент":null,"Комментарий":null,"Оценка самоаудита":null,"Комментарий самоаудита":null})
            result_part_name_data.push({"Подраздел":null,"Аудитор":null,"Уровень 1":array_selfesteem[0],"Уровень 2":array_selfesteem[1],"Уровень 3":array_selfesteem[2],"Уровень 4":array_selfesteem[3],"Уровень 5":array_selfesteem[4],"Пункт":null,"Условие":null,"Контрольный элемент":null,"Комментарий":null,"Оценка самоаудита":null,"Комментарий самоаудита":null})
        }

        for (let i = 0; i < 2; i++) {
                if (data.esteem_audit_id===null){
                    result_part_name_data.push({"Подраздел":null,"Аудитор":null,"Уровень 1":null,"Уровень 2":null,"Уровень 3":null,"Уровень 4":null,"Уровень 5":null,"Пункт":null,"Условие":null,"Контрольный элемент":null,"Комментарий":null})
                //вариант 2 самоаудит есть
                }else{
                result_part_name_data.push({"Подраздел":null,"Аудитор":null,"Уровень 1":null,"Уровень 2":null,"Уровень 3":null,"Уровень 4":null,"Уровень 5":null,"Пункт":null,"Условие":null,"Контрольный элемент":null,"Комментарий":null,"Оценка самоаудита":null,"Комментарий самоаудита":null})
                }
            }
        }
        //сохранение в общий объект данные по страницам/разделов для excel
        Object.assign(result_data,{[part_name]:result_part_name_data})
    }
    // console.log(result_data)
    return(result_data)
}